import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ElectionCategory } from '../../constants/categories';
import { RuleType, RuleStatus } from '../../constants/commission';

export interface CommissionRule {
  id: string;
  category: ElectionCategory;
  rule_type: RuleType;
  // Decimal string: "10.00" (percent: 10%) or "25.00" (fixed: rupees per order)
  value: string;
  effective_from: string;
  is_active: boolean;
  status: RuleStatus;
  // Once true, the version can never be deactivated: it was already used
  in_use: boolean;
  deactivated_at: string | null;
  deactivated_by: string | null;
  created_at: string;
  created_by: string;
}

export interface CommissionRuleGroup {
  category: ElectionCategory;
  // The version that applies to orders paid now; null = no commission for new orders
  current: CommissionRule | null;
  // Active versions with a future effective_from, soonest first
  scheduled: CommissionRule[];
  // Every version, newest effective_from first
  history: CommissionRule[];
}

export interface CommissionRuleState {
  groups: CommissionRuleGroup[];
  loading: boolean;
  error: string | null;
}

const initialState: CommissionRuleState = {
  groups: [],
  loading: false,
  error: null,
};

const commissionRuleSlice = createSlice({
  name: 'commissionRules',
  initialState,
  reducers: {
    setCommissionRuleLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setCommissionRuleError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setCommissionRuleGroups: (state, action: PayloadAction<CommissionRuleGroup[]>) => {
      state.groups = action.payload;
    },
  },
});

export const { setCommissionRuleLoading, setCommissionRuleError, setCommissionRuleGroups } =
  commissionRuleSlice.actions;

export default commissionRuleSlice.reducer;
